import React from 'react';
import MUIRadio, { RadioProps } from '@mui/material/Radio';
import MUIRadioGroup, { RadioGroupProps } from '@mui/material/RadioGroup';

export const MuiRadioGroup = (props: RadioGroupProps) => {
	return <MUIRadioGroup {...props} />;
};

export const MuiRadio = (props: RadioProps) => {
	return <MUIRadio {...props} />;
};
